import React from 'react';
import ProviderGroup from 'components/Tvendo/Commissions/DataMaster/ProviderGroup/List';

export default function () {
  return <ProviderGroup />;
}
